import { createSlice } from '@reduxjs/toolkit';
import { sar } from '../../../helpers/reduxHelper';
import { COLOR_TYPE } from '../admin/curatorStylesSlicer';

const getInitialState = () => ({
  open: false,
  colorId: null,
  color: null,
  colorType: COLOR_TYPE.RGB,
})

const configuratorColorDialog = createSlice({
  name: 'configuratorColorDialog',
  initialState: getInitialState(),
  reducers: {
    resetState: () => {
      return getInitialState();
    },
    open: (state, { payload }) => {
      state.open = true;
      state.colorId = payload.colorId || null;
      state.color = payload.color;
    },
    close: () => {
      return getInitialState();
    },
    updateColor: sar('color'),
    updateColorType: sar('colorType'),
  },
});

export const configuratorColorDialogActions = configuratorColorDialog.actions;
export const configuratorColorDialogReducer = configuratorColorDialog.reducer;

export const selectColorDialog = (state) => state.configuratorColorDialog;
export const selectColorDialogOpen = (state) => state.configuratorColorDialog.open;